import angular from 'angular';
import template from './textfield.html';
import kformUtils from '../../utils/kform-utils';

const textfieldConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('textfield', {
		title:      'Text Field',
		template,
		icon:       'fa fa-terminal',
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.maskOptions = {
				inputMask: String,
			};

			if ($scope.options?.building) {
				return;
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
		children:   false,
		selectable: true,
		settings:   {
			autofocus:    false,
			disabled:     false,
			input:        true,
			tableView:    true,
			inputType:    'text',
			inputMask:    '',
			label:        'Text',
			key:          'text',
			hideLabel:    false,
			placeholder:  '',
			prefix:       '',
			suffix:       '',
			defaultValue: '',
			protected:    false,
			persistent:   true,
			hidden:       false,
			clearOnHide:  true,
			spellcheck:   true,
			validate:     {
				card: '0-1',
				minLength:     null,
				maxLength:     null,
				pattern:       '',
				custom:        '',
			},
			conditional:  {
				show: null,
				when: null,
				eq:   '',
			},
			event:        {
				onChange: null,
			},
			kdata: {
				submit: true,
			},
		},
		views: [
			{
				name:     'Display',
				template: 'kform/components/textfield/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/textfield/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/textfield/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app').config(textfieldConfig);
